<script setup lang="ts">
const { t } = useResolvedI18n()
const localePath = useLocalePath()
const route = useRoute()

const slug = String(route.params.slug || '')
const { article } = await usePublicNewsArticle(slug)

// Expected missing article: set HTTP 404 without entering Nuxt error state
// (avoids DevTools "News not found" error pip).
if (!article.value) {
  const event = useRequestEvent()
  if (event) setResponseStatus(event, 404)
}

const html = computed(() => (article.value ? renderNewsHtml(article.value.body) : ''))

useHead({
  title: () =>
    article.value
      ? `${article.value.title} - ${t('brand.name')}`
      : t('error.title404'),
  meta: article.value
    ? [{ name: 'referrer', content: 'no-referrer' }]
    : undefined,
})
</script>

<template>
  <AppErrorState v-if="!article" :status-code="404" />

  <template v-else>
    <section
      class="page-banner"
      style="background-image: url('/images/campus-bg.jpg')"
    >
      <h2>{{ t('news.detailBanner') }}</h2>
      <div class="breadcrumb">
        <NuxtLink :to="localePath('/')">{{ t('common.home') }}</NuxtLink>
        &gt;
        <NuxtLink :to="localePath('/news')">{{ t('news.breadcrumb') }}</NuxtLink>
        &gt; {{ t('news.detailBanner') }}
      </div>
    </section>

    <section class="content-section">
      <div class="container">
        <article class="news-article content-card">
          <h1 class="news-article-title">{{ article.title }}</h1>
          <div class="news-article-meta">
            <time>{{ article.date }}</time>
            <span v-if="article.author">{{ article.author }}</span>
          </div>

          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="news-article-body markdown-body" v-html="html" />

          <p v-if="article.sourceUrl" class="news-article-source">
            <a :href="article.sourceUrl" target="_blank" rel="noopener">{{ t('news.viewSource') }}</a>
          </p>

          <p class="news-article-back">
            <NuxtLink :to="localePath('/news')" class="cta-btn">{{ t('news.backToList') }}</NuxtLink>
          </p>
        </article>
      </div>
    </section>
  </template>
</template>
